import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Accueil from './pages/Accueil/Accueil';
import Apropos from './pages/A-propos/A-propos';
import AntreConnaissance from './pages/AntreConnaissance/AntreConnaissance';
import EntreConnaissance from './pages/EntreConnaissance/EntreConnaissance';
import Contact from './pages/Contact/Contact';
import Error404 from './pages/Error404/Error404';
import Evenements from './pages/Event/Event';
import PageEvenementTemplate from './pages/PageEvenement/PageEvenementTemplate';
import { Analytics } from "@vercel/analytics/react"
import ScrollToTopButton from "./components/ScrollButton/ScrollButton";
import './App.css';


function App() {
  return (
    <div>
    <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="/a-propos" element={<Apropos />} />
        <Route path="/event" element={<Evenements />} />
        <Route path="/antreConnaissance" element={<AntreConnaissance />} />
        <Route path="/entreConnaissance" element={<EntreConnaissance />} />
        <Route path="/evenement/:slug" element={<PageEvenementTemplate />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="*" element={<Error404 />} />
    </Routes>
    <Analytics/>
    <ScrollToTopButton/>
    </div>
  );
}

export default App;
